'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _ramda = require('ramda');

var _evaluateCondition = require('./evaluateCondition');

var _evaluateCondition2 = _interopRequireDefault(_evaluateCondition);

var _conditionUtils = require('./conditionUtils');

var _reverseJsonPaths = require('./reverseJsonPaths');

var _reverseJsonPaths2 = _interopRequireDefault(_reverseJsonPaths);

var _getField = require('./getField');

var _getField2 = _interopRequireDefault(_getField);

var _getArrayMemberKey = require('./getArrayMemberKey');

var _getArrayMemberKey2 = _interopRequireDefault(_getArrayMemberKey);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var addFieldChangeEffects = function addFieldChangeEffects(hash, contingentFieldName, contingentFieldPropertyName, contingentFieldPropertyConditionalLogic, fieldKeyFromJsonPath) {
  var namesOfFieldsToTriggerChange = (0, _conditionUtils.getAllVarPaths)(contingentFieldPropertyConditionalLogic).map(fieldKeyFromJsonPath);
  namesOfFieldsToTriggerChange.filter(function (v) {
    return v;
  }).forEach(function (nameOfFieldToTriggerChange) {
    var changeTriggerField = hash[nameOfFieldToTriggerChange] = hash[nameOfFieldToTriggerChange] || {};
    var contingentField = changeTriggerField[contingentFieldName] = changeTriggerField[contingentFieldName] || {};
    contingentField[contingentFieldPropertyName] = contingentFieldPropertyConditionalLogic;
  });
  return hash;
};

var mapObjWithArrays = function mapObjWithArrays(fn, obj, fieldsJson) {
  var keys = Object.keys(obj);
  var onlyArrays = function onlyArrays(k) {
    return (/\[\]/.test(k)
    );
  };

  var arrayKeys = keys.filter(function (k) {
    return Array.isArray(obj[k][0]);
  });
  var arrays = arrayKeys.reduce(function (hash, arrayKey) {
    var _obj$arrayKey = _slicedToArray(obj[arrayKey], 2),
        jsonArrayPath = _obj$arrayKey[0],
        jsonArrayElementSchema = _obj$arrayKey[1];

    var finalKey = arrayKey;
    var resultArray = (0, _ramda.path)(jsonArrayPath, fieldsJson).map(function (arrayElement, index) {
      return (0, _ramda.mapObjIndexed)(function (jsonPath, arrayFieldKey) {
        var fullArrayFieldKey = finalKey + '[].' + arrayFieldKey;
        var pathBuilder = { jsonArrayPath: jsonArrayPath, index: index, jsonPath: jsonPath };
        return fn([].concat(_toConsumableArray(jsonArrayPath), [index], _toConsumableArray(jsonPath)), fullArrayFieldKey, fieldsJson, index);
      }, jsonArrayElementSchema);
    });
    hash[finalKey] = resultArray;
    return hash;
  }, {});

  var nonArrayKeys = (0, _ramda.difference)(keys, arrayKeys);
  var nonArrays = (0, _ramda.pipe)((0, _ramda.pick)(nonArrayKeys), (0, _ramda.mapObjIndexed)(function (a, b) {
    return fn(a, b, fieldsJson);
  }))(obj);

  return _extends({}, arrays, nonArrays);
};

var prettyPrintTableRow = function prettyPrintTableRow(left, right) {
  return left.padEnd(40, '-') + '-' + right.padStart(20, '-');
};

var forEachField = function forEachField(json, fn) {
  var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  var keys = Object.keys(json);
  keys.forEach(function (key) {
    var val = json[key];
    if (Array.isArray(val) || val && val.hasOwnProperty('value')) {
      return fn([].concat(_toConsumableArray(path), [key]), val);
    } else {
      return forEachField(val, fn, [].concat(_toConsumableArray(path), [key]));
    }
  });
};

var pathWithArrayIndex = function pathWithArrayIndex(thePath, obj, index) {
  if (index == null) return (0, _ramda.path)(thePath, obj);

  var current = obj;
  for (var i = 0; i < thePath.length; i++) {
    if (current == null) return undefined;
    current = Array.isArray(current) ? current[index][thePath[i]] : current[thePath[i]];
  }
  return current;
};

var processFields = function processFields(fieldsJson, jsonPaths) {
  var fieldChangeEffects = {};
  var absentFields = [];

  var reverseJsonPaths = (0, _reverseJsonPaths2.default)(jsonPaths);
  var fieldKeyFromJsonPath = function fieldKeyFromJsonPath(path) {
    return reverseJsonPaths[path];
  };
  // || console.error(`Could not build condition for field at ${path.join('.')} without corresponding field key`) // eslint-disable-line no-console

  var fields = mapObjWithArrays(function (jsonPath, fieldKey, fieldsJsonParam, index) {
    var fieldProperties = (0, _ramda.path)(jsonPath, fieldsJsonParam); // { readable: ..., editable: ..., value: ... }
    if (!fieldProperties) {
      absentFields.push({ jsonPath: jsonPath, fieldKey: fieldKey });
      return {};
    }
    return (0, _ramda.mapObjIndexed)(function (propertyValue, propertyName) {
      return (// e.g. (true, 'editable')
        (0, _conditionUtils.isConditionalValue)(propertyValue) ? (0, _evaluateCondition2.default)(propertyValue, function (varValue) {
          // build out fieldChangeEffects here so we don't have to loop through all fields twice
          fieldChangeEffects = addFieldChangeEffects(fieldChangeEffects, fieldKey, propertyName, propertyValue, fieldKeyFromJsonPath);

          var value = pathWithArrayIndex([].concat(_toConsumableArray(varValue), ['value']), fieldsJsonParam, index);
          return value;
        }) : propertyValue
      );
    }, fieldProperties);
  }, jsonPaths, fieldsJson);

  if (absentFields.length) {
    var pretty = absentFields.map(function (_ref) {
      var _ref$fieldKey = _ref.fieldKey,
          fieldKey = _ref$fieldKey === undefined ? 'undefined' : _ref$fieldKey,
          jsonPath = _ref.jsonPath;
      return prettyPrintTableRow(jsonPath.join('.'), '\'' + fieldKey + '\'');
    }).join('\n');
    // console.warn(`Could not find data for these ${absentFields.length} fields:\n${pretty}`)
  }

  var excessFields = [];
  forEachField(fieldsJson, function (path) {
    if (!reverseJsonPaths[path] && !Array.isArray(fieldsJson[path])) excessFields.push(path.join('.'));
  });
  if (excessFields.length) {
    // console.warn(`No field keys given for these values in the provided JSON:\n${excessFields.join('\n')}`)
  }

  return {
    fields: fields,
    fieldChangeEffects: fieldChangeEffects
  };
};

exports.default = processFields;


//////////////////
// WEBPACK FOOTER
// ./node_modules/form-metadata-2/dist/processFields.js
// module id = 813
// module chunks = 0